export default "__VITE_ASSET__CUbk9UWi__"